import Button from "components/atoms/button/Button";
import IconButton from "components/atoms/button/IconButton";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import Input from "components/atoms/input/Input";
import TextArea from "components/atoms/text-area/TextArea";
import PrimaryDatePicker from "components/molecules/datepicker/PrimaryDatePicker";
import InputsFolder from "components/molecules/inputs-folder/InputsFolder";
import { format, parseISO } from "date-fns";
import withModal from "lib/helpers/hoc/withModal";
import { useMakeDoneAppPending } from "lib/hooks/mutations/Pendings/useMakeDoneAppPending";
import { useMakeDoneOwnPending } from "lib/hooks/mutations/Pendings/useMakeDoneOwnPending";
import { useMakeDontLeadPending } from "lib/hooks/mutations/Pendings/useMakeDontLeadPending";
import { FC, useMemo } from "react";

import { useTranslation } from "react-i18next";

export interface IUpdateLeadAppPendingProps<T> {
    userData?: T;
    closeModal: () => void;
    isOwn?: boolean;
}

const UpdateLeadAppPending: FC<IUpdateLeadAppPendingProps<any>> = ({
    userData,
    closeModal,
    isOwn
}) => {

    const { t } = useTranslation();

    const isLead = useMemo(() => {

        if (userData?.appointment_id) {
            return false;
        }
        return true

    }, [userData])


    const formmatedData = useMemo(() => {

        return {
            ...userData,
            ...({ info: isLead ? userData.lead_info : userData.appointment_info }),
        };


    }, [userData, isLead])

    const { mutateAsync: leadDonePending, isLoading: isLeadDonePendingLoading } = useMakeDontLeadPending()

    const { mutateAsync: appDonePending, isLoading: isAppDonePendingLoading } = useMakeDoneAppPending()

    const { mutateAsync: ownDonePending, isLoading: isOwnDonePendingLoading } = useMakeDoneOwnPending()


    const ChangeStatus = () => {

        if (isOwn) {
            ownDonePending({
                pending_id: formmatedData?.id,
            }).then(() => {
                closeModal()
            })
            return
        }

        if (isLead) {
            leadDonePending({ pending_id: formmatedData?.id }).then(() => {
                closeModal()
            })
            return
        }
        appDonePending({
            pending_id: formmatedData?.id,
        }).then(() => {
            closeModal()
        })

    }

    return (
        <div className="flex flex-col gap-5">
            <div className="mb-0 flex flex-col gap-7 w-full">
                <Button
                    type="button"
                    className="absolute top-[26px] left-[30px] items-center capitalize sm:top-[31px] md:top-[45px] flex gap-4 font-inter-semibold text-[#282D46] text-[22px]"
                >
                    {!isOwn &&(
                        <>
                        {formmatedData?.info?.first_name}{" "}
                        {formmatedData?.info?.last_name} : {" "}
                        </>
                    )}
                    
                     {formmatedData?.pending_name}
                    <p
                        className={`min-w-[120px] cursor-pointer w-[max-content]  text-[16px] !font-inter-regular flex items-center justify-center rounded-[4px] capitalize 
                  ${formmatedData?.completed === 1
                                ? "bg-[#2DE28B] bg-opacity-[10%] text-[#2DE28B]"
                                : "bg-[#F88532] bg-opacity-[10%] text-[#F88532]"

                            }`}
                    >
                        {t(formmatedData?.completed === 1 ? "Completed" : "Open")}
                    </p>
                </Button>
            </div>
            {!isOwn && (
                <InputsFolder title={t("Pending Details")}>
                    <div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                            <Input
                                label="ID"
                                value={"#" + formmatedData?.info?.id}
                                readOnly
                                disabled
                            />
                            <Input
                                label={t("First Name")}
                                value={formmatedData?.info?.first_name}
                                readOnly
                                disabled
                            />
                            <Input
                                label={t("Last Name")}
                                value={formmatedData?.info?.last_name}
                                readOnly
                                disabled
                            />

                            <PrimaryDatePicker
                                label={t("Date Of Birth")}
                                startDate={formmatedData?.info?.birthdate}
                                wrapperClassName="!left-[2px]"
                                isDisabled={true}
                                value={formmatedData?.info?.birthdate}
                                setStartDate={() => { }}

                            />

                            <Input
                                label={t("Worker")}
                                value={formmatedData?.to_user_id}
                                readOnly
                                disabled
                            />
                        </div>




                    </div>
                </InputsFolder>
            )}

            <InputsFolder title={t("Pending Information")}>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-[20px]">
                    <Input
                        label={t("Category")}
                        value={formmatedData?.pending_type}
                        readOnly
                        disabled
                    />

                    <PrimaryDatePicker
                        label={t("Creation Date")}
                        startDate={format(parseISO(formmatedData.created_at), "yyyy-MM-dd")}
                        isDisabled={true}
                        value={format(parseISO(formmatedData.created_at), "yyyy-MM-dd")}
                        setStartDate={() => { }}
                    />


                    <PrimaryDatePicker
                        label={t("Deadline *")}
                        startDate={formmatedData?.deadline}
                        isDisabled={true}
                        wrapperClassName="!left-[2px]"
                        value={formmatedData?.deadline}
                        setStartDate={() => { }}

                    />

                    <div className="col-span-1 lg:col-span-3">
                        <TextArea
                            value={formmatedData?.description}
                            label={t("Description")}
                            disabled
                        />
                    </div>
                </div>
            </InputsFolder>

            <ConditionalRender condition={formmatedData?.completed !== 1}>
                <div className="pb-8">
                    <div className="flex items-center justify-end ml-auto gap-[15px]">
                        <IconButton
                            type="submit"
                            onClick={ChangeStatus}
                            disabled={isLeadDonePendingLoading || isAppDonePendingLoading || isOwnDonePendingLoading} >
                            {t("Pending Done")}
                        </IconButton>
                    </div>
                </div>
            </ConditionalRender>

        </div>
    );
};

export default withModal(UpdateLeadAppPending);
